import { Card, Col, Container, Row } from "react-bootstrap";
import LazyLoad from "react-lazyload";
import "./HiringManager.scss";
import HiringManagersService from "../../services/http/hiring-managers.service";

import { DEFAULT_PAGE_ROWS } from "../../constants/resume-forms-constants";
import { useEffect, useMemo, useState } from "react";
import { AxiosResponse } from "axios";
import { Redirect } from "react-router-dom";
import Pagination from "../../components/Pagination/Pagination";
import {
  USER_TYPE,
  DEFAULT_GRID_OPTION,
  DEFAULT_COL_DEF,
} from "../../constants/nav-constants";
import TableToolTip2 from "../../components/shared/TableToolTip2/TableToolTip2";
import HiringManagerTableActions from "../../components/shared/HiringManagerTableActions/HiringManagerTableActions";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import TableLinkRenderer from "../../components/shared/TableLinkRenderer/TableLinkRenderer";
import moment from "moment";
import { SETTING_INDEX } from "../../constants/select-option-constants";

const HiringManager = () => {
  const theUser = JSON.parse(localStorage.getItem("userDetails") || ``);
  const gridOptions = DEFAULT_GRID_OPTION;

  const defaultColDef = useMemo(() => {
    return DEFAULT_COL_DEF;
  }, []);

  const [columnDefs] = useState([
    { field: "fullName", headerName: `Name`, cellRenderer: TableLinkRenderer },
    { field: "position" },
    { field: "businessEmail" },
    { field: "personalEmail", width: 150 },
    { field: "businessPhoneNumber", width: 150, headerName: `Business Phone` },
    { field: "address" },
    {
      field: "relatedCompanies",
      cellRenderer: TableToolTip2,
    },
    {
      field: "relatedOpportunities",
      cellRenderer: TableToolTip2,
      width: 190,
    },
    {
      field: "relatedCandidates",
      cellRenderer: TableToolTip2,
    },
    { field: "dateCreatedFormatted", headerName: `Date Created`, width: 135 },
    { field: "dateModifiedFormatted", headerName: `Last Modified`, width: 140 },
    {
      field: "id",
      headerName: "",
      cellClass: "actions-button-cell",
      resizable: false,
      filter: false,
      width: 50,
      sortable: false,
      cellRenderer: HiringManagerTableActions,
      cellRendererParams: { theUser },
    },
  ]);

  const [tableData, setTableData] = useState<any[]>([]);
  const [searchText] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(DEFAULT_PAGE_ROWS);
  const [tableMeta, setTableMeta] = useState<any>({});
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const theUserSettings = JSON.parse(
      localStorage.getItem("userSettings") || ``
    );

    const mapTableData = (tableData: any = []) => {
      return tableData.map((item) => {
        item.fullName = `${item.firstName}`;
        item.dateCreatedFormatted =
          item.dateCreated &&
          moment(item.dateCreated).format(
            theUserSettings[SETTING_INDEX.DATE_FORMAT].settingValue
          );
        item.dateModifiedFormatted =
          item.dateModified &&
          moment(item.dateModified).format(
            theUserSettings[SETTING_INDEX.DATE_FORMAT].settingValue
          );
        return item;
      });
    };
    const getApplicants = (params: any = { PageSize: DEFAULT_PAGE_ROWS }) => {
      setIsLoading(true);
      HiringManagersService.getHiringManagers(params).then(
        (data: AxiosResponse) => {
          setIsLoading(false);
          if (data && data.data && data.data.data) {
            setTableMeta(data.data.meta);
            setTableData(mapTableData(data.data.data));
          }
        }
      );
    };

    getApplicants({
      SearchStr: searchText,
      PageSize: rowsPerPage,
      PageNumber: currentPage,
    });
  }, [currentPage, rowsPerPage, searchText]);

  return (
    <>
      {theUser.role === USER_TYPE.APPLICANT ? <Redirect to={`/profile`} /> : ``}

      <LazyLoad>
        <Container className="main-container" fluid>
          <Row>
            <Col>
              <Card className="main-card">
                <Card.Body className="p-0">
                  <div
                    className="ag-theme-alpine responsive table-bordered table-sm table-dp-small"
                    style={{ height: "80vh", width: "100%" }}
                  >
                    <AgGridReact
                      rowData={tableData}
                      gridOptions={gridOptions}
                      columnDefs={columnDefs}
                      defaultColDef={defaultColDef}
                    ></AgGridReact>
                  </div>

                  <Pagination
                    tableMeta={tableMeta}
                    isLoading={isLoading}
                    rowsPerPage={rowsPerPage}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    setRowsPerPage={setRowsPerPage}
                  ></Pagination>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </LazyLoad>
    </>
  );
};

export default HiringManager;
